import { FeatureFlag } from '../FeatureFlag';

export const enableColumnOptionsGlobalDefaultsPanel = new FeatureFlag({
    key: 'enable-column-options-global-defaults-panel',
    createdOn: '2025-11-23',
    defaultValue: false,
});
